import styled from 'styled-components';
import { fontFamilies } from '~/theme/typography';

interface TableProps {
  columns: string[];
  rows: (string | number)[][];
  keyExtension: string;
}
const alphabetList = [...'ABCDEFGHIJKLMNOPQRSTUVWXYZ'];

export const Table: React.FC<TableProps> = ({
  columns,
  rows,
  keyExtension,
}) => {
  const filteredEmptyRows = rows.filter((row) => row.length !== 0);

  return (
    <TableContainer>
      <StyledTable>
        <TableHead>
          <TableRow>
            {columns.map((col) => (
              <TableCell key={`header-${col}`}>{col}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <tbody>
          {filteredEmptyRows.map((row, rowIdx) => (
            <TableRow key={`${keyExtension}-${row[0]}`}>
              {row.map((cell, cellIdx) => (
                <TableCell
                  key={`cell-${keyExtension}-${cell}-${Math.random() * 20}`}
                >
                  {cellIdx === 0 && alphabetList[rowIdx] + ' '}
                  {cell}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </tbody>
      </StyledTable>
    </TableContainer>
  );
};

export const TableContainer = styled.div`
  box-shadow: none;
  width: unset;
  color: ${({ theme }) => theme.colors.text};
  background-color: transparent;
  border-bottom: 0;
  margin-bottom: 1.5rem;
`;

export const StyledTable = styled.table`
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
`;

export const TableRow = styled.tr`
  color: inherit;
  outline: 0;
  vertical-align: middle;

  & > th:first-child,
  & > td:first-child {
    width: 100%;
    min-width: 18.75rem;
    text-align: left;
    white-space: nowrap;
  }

  & > th:not(:first-child),
  & > td:not(:first-child) {
    text-align: center;
    white-space: nowrap;
  }
`;

export const TableHead = styled.thead`
  border-bottom: 1px solid ${({ theme }) => theme.colors.white};
`;

export const TableCell = styled.th`
  padding: 0.75rem;
  color: ${({ theme }) => theme.colors.white};
  font-family: ${fontFamilies.CircularStd};
  font-size: 1rem;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.03125rem;
  text-transform: uppercase;
  vertical-align: inherit;
`;
